import { createAction, props } from '@ngrx/store';

import { InviteToApply } from '@shared/models/invite-to-apply';

export const sendInviteToApply = createAction('[Invite To Apply] Send Invitation', props<{ inviteToApply: InviteToApply }>());

export const sendInviteToApplySuccess = createAction('[Invite To Apply] Send Invitation Success', props<{ response: InviteToApply }>());

export const sendInviteToApplySuccessClearMatchedCache = createAction(
  '[Invite To Apply] Send Invitation Success Clear Matched Cache',
  props<{ response: InviteToApply }>(),
);

export const sendInviteToApplyFail = createAction('[Invite To Apply] Send Invitation Fail', props<{ error: any }>());

export const sendJobPostUrlRequest = createAction(
  '[Invite To Apply] Send Job Post Url Request',
  props<{ clientReqId: string; jobId: number }>(),
);

export const hcmJobPostServiceSuccess = createAction(
  '[Invite To Apply] Send Job Post Url Request Success',
  props<{ url: string; jobId: number }>(),
);

export const hcmJobPostServiceFail = createAction(
  '[Invite To Apply] Send Job Post Url Request Fail',
  props<{ error: any; jobId: number }>(),
);

export const hcmJobPostShowError = createAction('[Invite To Apply] Job Post Url Show Error', props<{ jobId: string }>());

export const inviteToApplyUpdateSuccess = createAction(
  '[Invite To Apply] Invite To Apply Update Success',
  props<{ inviteToApply: InviteToApply }>(),
);
